import { escapeRegExp } from 'lodash-es';
import { InputRule } from 'prosemirror-inputrules';
import { EditorState } from 'prosemirror-state';
import { MentionPlugin } from '../plugins/MentionPlugin/MentionPlugin';
import { MentionMenuStore } from '../plugins/MentionPlugin/store';
import { Extension } from './base/Extension';

const mentionRegex = new RegExp(
  `(?:^|\\s|\\()${escapeRegExp('@')}([\\p{L}/\\p{M}\\d\\.\\-–_]+)?$`,
  'u'
);

export class MentionMenuTrigger extends Extension {
  constructor(private readonly state: MentionMenuStore) {
    super('mention-menu-trigger');
  }

  plugins() {
    return [new MentionPlugin(mentionRegex, this.state)];
  }

  inputRules() {
    return [
      new InputRule(mentionRegex, (state: EditorState, match: RegExpMatchArray) => {
        const { parent } = state.selection.$from;

        if (match && parent.type.name === 'paragraph') {
          if (match[0].length) {
            this.state.setOpen(true);
          } else {
            this.state.setOpen(false);
          }
          this.state.setQuery(match[1]);
        }

        return null;
      }),
    ];
  }
}
